const WEBPAGES = {
    ZTUDENT: {
        DASHBOARD: 1,
        COURSE: 13,
        RESULTS: 14,
        RESULTS_ITEMS: 19,
        VIEWER: 17
    },
    INSTRUCTOR: {
        DASHBOARD: 2,
        GROUPS: 3,
        GROUPS_CREATE: 4,
        GROUP: 5,
        ZTUDENTS: 6,
        CHANGE_GROUP: 7,
        AGENDA: 8,
        AGENDA_CREATE: 18,
        PROGRESS: 9,
        RESULTS: 10,
        ZTUDENTVIEW: 11,
        SYLLABUS: 12,
        SETTINGS: 16
    },
    LEADER: {
        DASHBOARD: 15
    }
}

// leader: {
//     dashboard: 1
// },
// instructor: {
//     dashboard: 2
// },
// ztudent: {
//     dashboard: 3
// }

export { WEBPAGES };